import IStep from '../../lib/IStep';
import Api from '../../services/Api';
import BusinessModel from '../FindYourBusiness/models/BusinessModel';
import DesignModel from './models/DesignModel';

export default class Step implements IStep {
  /**
   * Fired when the step is initialized
   */
  async onInit() {}
}
